import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-License-Identifier: AGPL-3.0-or-later
import { createContext, useContext, useMemo } from 'react';
import { translate } from './dictionary.js';
import {} from './languages.js';
const LanguageContext = createContext(null);
/**
 * Patient-side language context. The Renderer reads `lang` to pick
 * the correct translation extension off each item; chrome strings
 * go through `t(...)`. Default fallback (when no provider is
 * mounted) is English — keeps standalone tests of single field
 * components working without ceremony.
 */
export function LanguageProvider({ lang, children }) {
    const value = useMemo(() => ({
        lang,
        t: (key, args) => translate(lang, key, args),
    }), [lang]);
    return _jsx(LanguageContext.Provider, { value: value, children: children });
}
/**
 * Returns the current language + translator. Outside a provider this
 * returns the English defaults — every field component still works
 * if it's mounted standalone, just without translations.
 */
export function useLanguage() {
    const ctx = useContext(LanguageContext);
    if (ctx !== null)
        return ctx;
    return {
        lang: 'en',
        t: (key, args) => translate('en', key, args),
    };
}
//# sourceMappingURL=LanguageProvider.js.map